// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noData {\n  height: 100%;\n  width: 100%;\n}\n.noData .el-collapse {\n  border: 0;\n}\n.noData .el-empty {\n  height: 100%;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
